module.exports = __webpack_public_path__ + "static/media/MontserratAlternates-Black.afa40ea8.ttf";